module.exports = __webpack_public_path__ + "static/img/case3-bg.a53a789.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/case3-bg.jpg
// module id = kn9X
// module chunks = 0